import React from "react";
import { useLanguage } from "../context/LanguageContext";

// Mirrors ThemeSelector's shape so the two controls in the Settings modal
// sit at the same height, width, and visual weight. Native <select> keeps
// the markup tiny and inherits the form-control baseline (height, radius,
// focus ring) from index.css.
const LANGUAGE_OPTIONS = [
  { code: "en", label: "🇬🇧 English" },
  { code: "ur", label: "🇵🇰 اردو" },
];

const LanguageSelector = () => {
  const { language, changeLanguage } = useLanguage();

  return (
    <label className="flex items-center gap-1 sm:gap-2 text-xs font-medium text-[var(--color-text-muted)]">
      <span className="hidden sm:inline">Language</span>
      <select
        value={language}
        onChange={(event) => changeLanguage(event.target.value)}
        className="rounded-lg border border-[var(--color-border)] bg-[var(--color-surface-muted)] px-1.5 py-1.5 sm:px-2 sm:py-2 text-xs font-semibold text-[var(--color-text-strong)] shadow-sm focus:border-[var(--color-border-strong)] focus:outline-none focus:ring-2 focus:ring-[var(--color-border-strong)]"
      >
        {LANGUAGE_OPTIONS.map((option) => (
          <option key={option.code} value={option.code}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
};

export default LanguageSelector;
